export default __webpack_public_path__ + "static/media/tony-2.75c08466.jpg";